// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"290e246c","977":"28185825"}[chunkId] + ".chunk.js";
};